import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class ModalService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._isOpen = false;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new ModalService(singletonEnforcer);
    }
    return this[singleton];
  }

  get isOpen() {
    return this._isOpen;
  }

  open() {
    window.document.body.classList.add('popin-vue-open');
    this._isOpen = true;
    this.emit('toggle', this._isOpen);
  }

  close() {
    window.document.body.classList.remove('popin-vue-open');
    this._isOpen = false;
    this.emit('toggle', this._isOpen);
  }

}
export default ModalService.getInstance();